module.exports = __webpack_public_path__ + "img/import.d837063d.svg";